import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VuereSource from 'vue-resource'
import infiniteScroll from 'vue-infinite-scroll'
import api from './api' // 导入api接口
/*import ElementUI from 'element-ui';*/
import {Dropdown, DropdownMenu, DropdownItem,Button,Loading,Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import malMainPageConfig from './views/MalMainPageConfig.vue'
Vue.config.productionTip = false
Vue.use(VuereSource);
Vue.use(infiniteScroll);
/*Vue.use(ElementUI);*/
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 8000 };
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Loading);
// Vue.use(Message);
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$message = Message
// /** 测试 **/
// Vue.prototype.$malMainPageConfig = malMainPageConfig; //引入全局配置
// malMainPageConfig.isShowSelf=true;

// store.commit({
//     type:'updateMalMainPageConfig',
//     malMainPageConfig : malMainPageConfig
// })
// new Vue({
//     router,
//     store,
//     data(){
//     },
//     render: h => h(App),
// }).$mount('#app');
/** 测试 **/

api.mainpageApi.getMainPageConfig().then(response=>{
    // Vue.prototype.$malMainPageConfig = response.data.data;
    let malMainPageConfig = response.data.data;
    malMainPageConfig.isShowSelf=true;
    store.commit({
        type: "updateSource",
        source: malMainPageConfig.source.defaultsource
      });
    store.commit({
        type:'updateMalMainPageConfig',
        malMainPageConfig : malMainPageConfig
    })
    api.mainpageApi.getCartNum().then(response=>{
        store.commit({
            type:'updateCartNum',
            currentNum:response.data.data
        });
    });
    new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
  }).catch((error=>{

}));






